type FormatParams = {
  /** @description фоллбек для символа валюты, если браузер не поддерживает Intl */
  currencySign?: string
  /** @description спрятать числа после запятой */
  hideFractionDigits?: boolean
}

export function numberFormatToCurrency(
  mayBeNumber: number | string,
  currency: string = 'RUB',
  country: string = 'ru-RU',
  params: FormatParams = {},
): string {
  const number: number = typeof mayBeNumber === 'string' ? Number.parseFloat(mayBeNumber) : mayBeNumber
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }

  if (params.hideFractionDigits === true || Number.isInteger(number)) {
    Object.assign(options, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }

  try {
    return new Intl.NumberFormat(country, options).format(number)
  } catch (err) {
    return `${number} ${params.currencySign || currency}`
  }
}
